class GlobalSiteRedirect {
  constructor() {
    window.addEventListener('orbito:ready', this.setupRedirect.bind(this))
    this.waitForOrbito()
  }

  waitForOrbito(retries = 30) {
    if (
      typeof orbito !== 'undefined' &&
      orbito.localCountry !== undefined &&
      orbito.remoteCountryCode !== undefined &&
      orbito.elements !== undefined
    ) {
      window.dispatchEvent(new CustomEvent('orbito:ready'))
    } else if (retries > 0) {
      setTimeout(() => this.waitForOrbito(retries - 1), 100)
    } else {
      console.error(
        'Orbito and required Orbito properties were not found. Cannot enable #geo redirect.'
      )
    }
  }

  setupRedirect() {
    if (!this.hasGeoHash) return

    const { localCountry, remoteCountryCode, elements } = orbito
    if (localCountry === remoteCountryCode) return
    window.history.replaceState(
      {},
      '',
      window.location.href.replace('#geo', '')
    )

    const { formUlCountrySelect, formMDAppCTAText } = elements
    this.selectRedirectCountry(
      formUlCountrySelect,
      remoteCountryCode,
      formMDAppCTAText
    )
  }

  selectRedirectCountry(countrySelectElement, countryCode, submitButton) {
    const country = countrySelectElement.querySelector(
      `[data-country="${countryCode}"]`
    )
    if (!country) return

    country.click()
    submitButton.click()
  }

  get hasGeoHash() {
    const url = new URL(window.location.href)
    return url.hash.includes('#geo')
  }
}

if (typeof GlobalSiteRedirect !== 'undefined') {
  new GlobalSiteRedirect()
}
